import { I9nSchemaBySystem } from '@biteinc/common';
import { allEnumValues, CardSchemeId, Gateway, IntegrationSystem, KioskDeviceTypeHelper, KioskOs, KioskPaymentTerminalModel, PaymentProcessor, } from '@biteinc/enums';
import { UniversalPaymentHelper } from '@biteinc/helpers-universal';
export const CardConnectTestMid = '800000000302';
export const WorldpayTestAccountIds = ['1059536', '1103198'];
// Return null instead of undefined so that the TS compiler performs a check that all enum values
// are handled in the switch statement.
export function i9nSystemForGateway(gateway, cardSchemeId) {
    switch (gateway) {
        case Gateway.Adyen:
            return IntegrationSystem.Adyen;
        case Gateway.Archer:
            return IntegrationSystem.Archer;
        case Gateway.AtriumLoyalty:
            return IntegrationSystem.AtriumLoyalty;
        case Gateway.AtriumStoredValue:
            return IntegrationSystem.AtriumStoredValue;
        case Gateway.CardConnect:
            return IntegrationSystem.CardConnect;
        case Gateway.CbordStoredValue:
            return IntegrationSystem.CbordCampusCard;
        case Gateway.FreedomPayStoredValue:
            return IntegrationSystem.FreedomPayStoredValue;
        case Gateway.QuickchargeCampusCard:
            return IntegrationSystem.QuickchargeCampusCard;
        case Gateway.Chase:
            return IntegrationSystem.Chase;
        case Gateway.ChoptLoyalty:
            return IntegrationSystem.ChoptLoyalty;
        case Gateway.Como:
            return IntegrationSystem.Como;
        case Gateway.Eigen:
            return IntegrationSystem.Eigen;
        case Gateway.EigenStoredValue:
            return IntegrationSystem.EigenStoredValue;
        case Gateway.Elavon:
            return IntegrationSystem.Elavon;
        case Gateway.FreedomPayFlash:
            return IntegrationSystem.FreedomPayFlash;
        case Gateway.FreedomPayKiosk:
            return IntegrationSystem.FreedomPayKiosk;
        case Gateway.Givex:
            return IntegrationSystem.Givex;
        case Gateway.GivexLoyalty:
            return IntegrationSystem.GivexLoyalty;
        case Gateway.Glory:
            return IntegrationSystem.Glory;
        case Gateway.Heartland:
            return IntegrationSystem.Heartland;
        case Gateway.LovesRewards:
            return IntegrationSystem.LovesRewards;
        case Gateway.Moneris:
            return IntegrationSystem.Moneris;
        case Gateway.None:
        case Gateway.CreditCall:
        case Gateway.LevelUp:
        case Gateway.Square:
            return null;
        case Gateway.OLOGift:
            return IntegrationSystem.OloStoredValue;
        case Gateway.OloPayKioskOrderingApi:
            return IntegrationSystem.OloPayKioskOrderingApi;
        case Gateway.OloPayKioskPaymentApi:
            return IntegrationSystem.OloPayKioskPaymentApi;
        case Gateway.ParPay:
            return IntegrationSystem.ParPay;
        case Gateway.PaytronixGift:
            return IntegrationSystem.PaytronixGift;
        case Gateway.PinataCashMachine:
            return IntegrationSystem.PinataCashMachine;
        case Gateway.PinataLoyalty:
            return IntegrationSystem.PinataLoyalty;
        case Gateway.PinataPay:
            return IntegrationSystem.PinataPay;
        case Gateway.PinataPayNative:
            return IntegrationSystem.PinataPayNative;
        case Gateway.PinataStoredValue:
            return IntegrationSystem.PinataStoredValue;
        case Gateway.PinataCampusCard:
            return IntegrationSystem.PinataCampusCard;
        case Gateway.TransactCampusCard:
            return IntegrationSystem.TransactCampusCard;
        case Gateway.Punchh:
            return IntegrationSystem.Punchh;
        case Gateway.Appfront:
            return IntegrationSystem.Appfront;
        case Gateway.SmoothCommerce:
            return IntegrationSystem.SmoothCommerce;
        case Gateway.Spendgo:
            return IntegrationSystem.Spendgo;
        case Gateway.Starbucks:
            return cardSchemeId === CardSchemeId.StarbucksInAppPayment
                ? IntegrationSystem.StarbucksFullLoyalty
                : IntegrationSystem.StarbucksPayAndEarnLoyalty;
        case Gateway.StarbucksStoredValue:
            return IntegrationSystem.StarbucksStoredValue;
        case Gateway.Stripe:
            return IntegrationSystem.Stripe;
        case Gateway.StripeTerminal:
            return IntegrationSystem.StripeTerminal;
        case Gateway.TCC:
            return IntegrationSystem.Tcc;
        case Gateway.Thanx:
            return IntegrationSystem.Thanx;
        case Gateway.Valutec:
            return IntegrationSystem.Valutec;
        case Gateway.VerifonePointCloud:
            return IntegrationSystem.VerifonePointCloud;
        case Gateway.VerifonePointSca:
            return IntegrationSystem.VerifonePointSca;
        case Gateway.Worldpay:
            return cardSchemeId === CardSchemeId.WorldpayGiftCard
                ? IntegrationSystem.WorldpayStoredValue
                : IntegrationSystem.Worldpay;
    }
}
export function gatewayForI9nSystem(system) {
    if (system === IntegrationSystem.WorldpayStoredValue) {
        return Gateway.Worldpay;
    }
    return allEnumValues(Gateway).find((gateway) => {
        return i9nSystemForGateway(gateway) === system;
    });
}
export function urlOnGateway(transactionData) {
    const { gateway, i9nId } = transactionData;
    if (!i9nId) {
        return null;
    }
    switch (gateway) {
        case Gateway.Square:
            return `https://squareup.com/dashboard/sales/transactions/${i9nId}`;
        case Gateway.CardConnect:
            if (!transactionData.json) {
                return null;
            }
            const json = transactionData.json instanceof Array ? transactionData.json[0] : transactionData.json;
            if (!json.merchid || json.merchid === CardConnectTestMid) {
                return null;
            }
            return `https://www.cardpointe.com/account/#/reporting/transactiondetail/R${i9nId}`;
        case Gateway.Stripe:
        case Gateway.StripeTerminal:
            // Its a refund
            if (!transactionData.json.paymentIntent) {
                return null;
            }
            if (transactionData.json.paymentIntent.livemode) {
                // If the transaction does not have a JSON object, assume it is live
                return `https://dashboard.stripe.com/payments/${i9nId}`;
            }
            return `https://dashboard.stripe.com/test/payments/${i9nId}`;
        case Gateway.Adyen:
        case Gateway.Archer:
        case Gateway.AtriumLoyalty:
        case Gateway.AtriumStoredValue:
        case Gateway.CbordStoredValue:
        case Gateway.QuickchargeCampusCard:
        case Gateway.Chase:
        case Gateway.ChoptLoyalty:
        case Gateway.Como:
        case Gateway.CreditCall:
        case Gateway.Eigen:
        case Gateway.EigenStoredValue:
        case Gateway.Elavon:
        case Gateway.FreedomPayFlash:
        case Gateway.FreedomPayKiosk:
        case Gateway.FreedomPayStoredValue:
        case Gateway.Givex:
        case Gateway.GivexLoyalty:
        case Gateway.Glory:
        case Gateway.Heartland:
        case Gateway.LevelUp:
        case Gateway.LovesRewards:
        case Gateway.Moneris:
        case Gateway.None:
        case Gateway.OLOGift:
        case Gateway.OloPayKioskOrderingApi:
        case Gateway.OloPayKioskPaymentApi:
        case Gateway.ParPay:
        case Gateway.PaytronixGift:
        case Gateway.PinataCashMachine:
        case Gateway.PinataLoyalty:
        case Gateway.PinataPay:
        case Gateway.PinataPayNative:
        case Gateway.PinataCampusCard:
        case Gateway.PinataStoredValue:
        case Gateway.Punchh:
        case Gateway.Appfront:
        case Gateway.SmoothCommerce:
        case Gateway.Spendgo:
        case Gateway.Starbucks:
        case Gateway.StarbucksStoredValue:
        case Gateway.TCC:
        case Gateway.Thanx:
        case Gateway.TransactCampusCard:
        case Gateway.Valutec:
        case Gateway.VerifonePointCloud:
        case Gateway.VerifonePointSca:
        case Gateway.Worldpay:
            return null;
    }
}
export const transactionIsSuccessful = UniversalPaymentHelper.transactionIsSuccessful;
export const gatewayUsesAuthAndCapture = UniversalPaymentHelper.gatewayUsesAuthAndCapture;
export function gatewaySupportsTransactionLookup(gateway, processor) {
    switch (gateway) {
        case Gateway.Eigen:
            return processor === PaymentProcessor.Eigen;
        case Gateway.CardConnect:
        case Gateway.OloPayKioskPaymentApi:
        case Gateway.VerifonePointCloud:
        case Gateway.VerifonePointSca:
        case Gateway.Worldpay:
            return true;
        case Gateway.Adyen:
        case Gateway.Archer:
        case Gateway.AtriumLoyalty:
        case Gateway.AtriumStoredValue:
        case Gateway.CbordStoredValue: // @todo: add to card present PR
        case Gateway.Chase:
        case Gateway.ChoptLoyalty:
        case Gateway.Como:
        case Gateway.CreditCall:
        case Gateway.EigenStoredValue:
        case Gateway.Elavon:
        case Gateway.FreedomPayFlash:
        case Gateway.FreedomPayKiosk:
        case Gateway.FreedomPayStoredValue:
        case Gateway.Givex:
        case Gateway.GivexLoyalty:
        case Gateway.Glory:
        case Gateway.Heartland:
        case Gateway.LevelUp:
        case Gateway.LovesRewards:
        case Gateway.Moneris:
        case Gateway.None:
        case Gateway.OLOGift:
        case Gateway.OloPayKioskOrderingApi:
        case Gateway.ParPay:
        case Gateway.PaytronixGift:
        case Gateway.PinataCashMachine:
        case Gateway.PinataLoyalty:
        case Gateway.PinataPay:
        case Gateway.PinataPayNative:
        case Gateway.PinataCampusCard:
        case Gateway.PinataStoredValue:
        case Gateway.Punchh:
        case Gateway.QuickchargeCampusCard:
        case Gateway.Appfront:
        case Gateway.SmoothCommerce:
        case Gateway.Spendgo:
        case Gateway.Square:
        case Gateway.Starbucks:
        case Gateway.StarbucksStoredValue:
        case Gateway.Stripe:
        case Gateway.StripeTerminal:
        case Gateway.TCC:
        case Gateway.Thanx:
        case Gateway.TransactCampusCard:
        case Gateway.Valutec:
            return false;
    }
}
export const gatewaySupportsPartialRefunds = UniversalPaymentHelper.gatewaySupportsPartialRefunds;
export function gatewaySupportsCardNotPresentRefund(gateway) {
    switch (gateway) {
        case Gateway.Adyen:
        case Gateway.Archer:
        case Gateway.AtriumLoyalty:
        case Gateway.AtriumStoredValue:
        case Gateway.CardConnect:
        case Gateway.CbordStoredValue:
        case Gateway.QuickchargeCampusCard:
        case Gateway.Chase:
        case Gateway.ChoptLoyalty:
        case Gateway.Como:
        case Gateway.CreditCall:
        case Gateway.Eigen:
        case Gateway.Elavon:
        case Gateway.FreedomPayFlash:
        case Gateway.FreedomPayKiosk:
        case Gateway.FreedomPayStoredValue:
        case Gateway.Givex:
        case Gateway.GivexLoyalty:
        case Gateway.Heartland:
        case Gateway.LevelUp:
        case Gateway.LovesRewards:
        case Gateway.Moneris:
        case Gateway.None:
        case Gateway.OLOGift:
        case Gateway.OloPayKioskOrderingApi:
        case Gateway.OloPayKioskPaymentApi:
        case Gateway.ParPay:
        case Gateway.PaytronixGift:
        case Gateway.PinataPay:
        case Gateway.PinataPayNative:
        case Gateway.PinataCampusCard:
        case Gateway.PinataStoredValue:
        case Gateway.PinataLoyalty:
        case Gateway.Punchh:
        case Gateway.Square:
        case Gateway.Starbucks:
        case Gateway.StarbucksStoredValue:
        case Gateway.Stripe:
        case Gateway.StripeTerminal:
        case Gateway.Spendgo:
        case Gateway.TCC:
        case Gateway.Appfront:
        case Gateway.SmoothCommerce:
        case Gateway.Thanx:
        case Gateway.TransactCampusCard:
        case Gateway.Valutec:
        case Gateway.VerifonePointCloud:
        case Gateway.VerifonePointSca:
        case Gateway.Worldpay:
            return true;
        case Gateway.EigenStoredValue:
        case Gateway.Glory:
        case Gateway.PinataCashMachine:
            return false;
    }
}
export function allPaymentFields() {
    return [
        'paymentTerminalModel',
        'paymentTerminalSerialNumber',
        'paymentTerminalIpAddress',
        'hasHid',
    ];
}
function getI9nSpecificKioskPaymentFields(system, paymentTerminalModel, isIOS) {
    switch (system) {
        case IntegrationSystem.Adyen:
        case IntegrationSystem.AurusPay:
        case IntegrationSystem.CardConnect:
        case IntegrationSystem.Eigen:
        case IntegrationSystem.OloPayKioskOrderingApi:
        case IntegrationSystem.OloPayKioskPaymentApi:
        case IntegrationSystem.ParPay:
        case IntegrationSystem.StripeTerminal:
        case IntegrationSystem.VerifonePointCloud:
        case IntegrationSystem.Worldpay:
            return ['paymentTerminalSerialNumber'];
        case IntegrationSystem.Chase:
        case IntegrationSystem.Elavon:
        case IntegrationSystem.VerifonePointSca:
            return ['paymentTerminalIpAddress'];
        case IntegrationSystem.Moneris:
            return ['paymentTerminalSerialNumber', 'paymentTerminalIpAddress'];
        case IntegrationSystem.Heartland:
            if (KioskPaymentTerminalModel.PaxA35 === paymentTerminalModel ||
                KioskPaymentTerminalModel.VerifoneP630 === paymentTerminalModel) {
                return ['paymentTerminalSerialNumber', 'paymentTerminalIpAddress'];
            }
            return ['paymentTerminalSerialNumber'];
        case IntegrationSystem.FreedomPayKiosk: {
            if (KioskPaymentTerminalModel.IngenicoISMP4 === paymentTerminalModel ||
                KioskPaymentTerminalModel.IngenicoLink2500 === paymentTerminalModel ||
                KioskPaymentTerminalModel.IngenicoLink2500i === paymentTerminalModel ||
                isIOS) {
                return ['paymentTerminalSerialNumber', 'paymentTerminalIpAddress'];
            }
            return ['paymentTerminalSerialNumber'];
        }
        case IntegrationSystem.PinataPay:
        case IntegrationSystem.PinataPayNative:
            return [];
    }
}
export function kioskPaymentFields(kioskPaymentSystem, storedValueSystems, paymentTerminalModel, kioskDeviceType) {
    const fields = [];
    if (kioskPaymentSystem) {
        fields.push('paymentTerminalModel');
        fields.push(...getI9nSpecificKioskPaymentFields(kioskPaymentSystem, paymentTerminalModel, kioskDeviceType ? KioskDeviceTypeHelper.toKioskOs(kioskDeviceType) === KioskOs.iOS : false));
    }
    const someStoredValueHasHid = storedValueSystems.some((system) => I9nSchemaBySystem[system].supportsHid);
    if (someStoredValueHasHid) {
        fields.push('hasHid');
    }
    return fields;
}
export function requiredKioskPaymentFields(kioskPaymentSystem, paymentTerminalModel, isIOS) {
    const fields = [];
    if (kioskPaymentSystem) {
        fields.push('paymentTerminalModel');
        fields.push(...getI9nSpecificKioskPaymentFields(kioskPaymentSystem, paymentTerminalModel, isIOS));
    }
    return fields;
}
/**
 * @description This method has the supported systems in the return type so that a consuming
 * function could use the return value in its own switch statement and guarantee that all cases are
 * being handled.
 */
export function systemSupportsUpdatePushes(system) {
    switch (system) {
        case IntegrationSystem.FreedomPayKiosk:
        case IntegrationSystem.Heartland:
            return system;
        case IntegrationSystem.Adyen:
        case IntegrationSystem.AurusPay:
        case IntegrationSystem.CardConnect:
        case IntegrationSystem.Chase:
        case IntegrationSystem.Eigen:
        case IntegrationSystem.Elavon:
        case IntegrationSystem.Moneris:
        case IntegrationSystem.OloPayKioskOrderingApi:
        case IntegrationSystem.OloPayKioskPaymentApi:
        case IntegrationSystem.ParPay:
        case IntegrationSystem.PinataPay:
        case IntegrationSystem.PinataPayNative:
        case IntegrationSystem.StripeTerminal:
        case IntegrationSystem.VerifonePointCloud:
        case IntegrationSystem.VerifonePointSca:
        case IntegrationSystem.Worldpay:
            return null;
    }
}
export function systemSupportsMultiplePaymentIntegrations(system) {
    return [IntegrationSystem.Stripe, IntegrationSystem.StripeTerminal].includes(system);
}
export function paymentIntegrationSupportsReboot(system) {
    switch (system) {
        case IntegrationSystem.AurusPay:
        case IntegrationSystem.Moneris:
        case IntegrationSystem.ParPay:
            return true;
        case IntegrationSystem.Adyen:
        case IntegrationSystem.CardConnect:
        case IntegrationSystem.Chase:
        case IntegrationSystem.Eigen:
        case IntegrationSystem.Elavon:
        case IntegrationSystem.FreedomPayKiosk:
        case IntegrationSystem.Heartland:
        case IntegrationSystem.OloPayKioskOrderingApi:
        case IntegrationSystem.OloPayKioskPaymentApi:
        case IntegrationSystem.PinataPay:
        case IntegrationSystem.PinataPayNative:
        case IntegrationSystem.StripeTerminal:
        case IntegrationSystem.VerifonePointCloud:
        case IntegrationSystem.VerifonePointSca:
        case IntegrationSystem.Worldpay:
            return false;
        default:
            system;
            return false;
    }
}
//# sourceMappingURL=payment_helper.js.map